import { defineComponent as _defineComponent } from 'vue'
import { TUITranslateService, TUIGlobal } from "@tencentcloud/chat-uikit-engine";
import {
  watchEffect,
  ref,
  defineProps,
  defineEmits,
} from "../../../adapter-vue";
import Slider from "../../common/Slider/index.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'manage-admin',
  props: {
  member: {
    type: Object,
    default: () => { },
  },
  isSetMuteTime: {
    type: Boolean,
    default: () => false,
  },
  currentGroup: {
    type: Object,
    default: () => { },
  },
},
  emits: [
  "addAdmin",
  "removeAdmin",
  "setAllMuteTime",
  "addMute",
  "removeMute",
  "toggleEdit"
],
  setup(__props, { emit: emits }) {

const props = __props



const isAdminSetMuteTime = ref(false);
const memberAdmin = ref({});
const currentGroupAdmin = ref({});
const isUniFrameWork = ref(typeof uni !== 'undefined');

watchEffect(() => {
  memberAdmin.value = props.member;
  isAdminSetMuteTime.value = props.isSetMuteTime;
  currentGroupAdmin.value = props.currentGroup;
});



const addAdmin = () => {
  emits("addAdmin");
};

const removeAdmin = () => {
  emits("removeAdmin");
};

const setAllMuteTime = (value: boolean) => {
  emits("setAllMuteTime", value);
};

const addMute = () => {
  emits("addMute");
};

const removeMute = () => {
  emits("removeMute");
};

const toggleEdit = async (tabName: string) => {
  emits("toggleEdit", tabName);
};

return { __sfc: true,props, isAdminSetMuteTime, memberAdmin, currentGroupAdmin, isUniFrameWork, emits, addAdmin, removeAdmin, setAllMuteTime, addMute, removeMute, toggleEdit, TUITranslateService, Slider }
}

})